import PostSkeleton from './PostSkeleton'

const PostListSkeleton = ({perPage}) => {
    const skeletonPosts = [];
    for (let i = 0; i < perPage; i++) {
        skeletonPosts.push(<PostSkeleton key={i}/>);
    }

    return (
        <div className="post-list posts-wrapper">
            {skeletonPosts}
        </div>
    )
}

export default PostListSkeleton